var animation = '';

var digitalDesignObserver = new IntersectionObserver(entry => {
    var digitalDesignText = document.querySelector(".digital-design-text");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeInLeft ';
        digitalDesignText.style.setProperty('--animate-duration', '1s');
        digitalDesignText.className += animation;
    }
});

var developmentObserver = new IntersectionObserver(entry => {
    var developmentText = document.querySelector(".development-text");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeInRight ';
        developmentText.style.setProperty('--animate-duration', '1s');
        developmentText.className += animation;
    }
});

var consultancyObserver = new IntersectionObserver(entry => {
    var consultancyText = document.querySelector(".consultancy-text");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeInLeft ';
        consultancyText.style.setProperty('--animate-duration', '1s');
        consultancyText.className += animation;
    }
});

var atTheMMCObserver = new IntersectionObserver(entry => {
    var atTheMMCText = document.querySelector(".at-the-mmc-text");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeIn ';
        atTheMMCText.style.setProperty('--animate-duration', '0.8s');
        atTheMMCText.className += animation;
    }
});

var ourProcessObserver = new IntersectionObserver(entry => {
    var ourProcessText = document.querySelector(".our-process-text");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeIn ';
        ourProcessText.style.setProperty('--animate-duration', '2s');
        ourProcessText.className += animation;
    }
});

var collaborativeExecutionObserver = new IntersectionObserver(entry => {
    var collaborativeExecutionText = document.querySelector(".collaborative-execution-text");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeIn ';
        collaborativeExecutionText.style.setProperty('--animate-duration', '2s');
        collaborativeExecutionText.className += animation;
    }
});

var companyLogosSectionObserver = new IntersectionObserver(entry => {
    var companyLogosSection = document.querySelector(".company-logos-section");
    // Element enters the viewport
    if(entry[0].intersectionRatio !== 0) {
        animation = ' animate__animated animate__fadeIn ';
        companyLogosSection.style.setProperty('--animate-duration', '2.5s');
        companyLogosSection.className += animation;
    }
});

var digitalDesignText = document.querySelector(".digital-design-text");
var developmentText = document.querySelector(".development-text");
var consultancyText = document.querySelector(".consultancy-text");
var atTheMMCText = document.querySelector(".at-the-mmc-text");
var ourProcessText = document.querySelector(".our-process-text");
var collaborativeExecutionText = document.querySelector(".collaborative-execution-text");
var companyLogosSection = document.querySelector(".company-logos-section");
console.log(digitalDesignText);
if(digitalDesignText !== null
) {
    console.log('in the if statement');
    digitalDesignObserver.observe(digitalDesignText);
    developmentObserver.observe(developmentText);
    consultancyObserver.observe(consultancyText);
    atTheMMCObserver.observe(atTheMMCText);
    ourProcessObserver.observe(ourProcessText);
    collaborativeExecutionObserver.observe(collaborativeExecutionText);
    companyLogosSectionObserver.observe(companyLogosSection);

}

